module.exports = __webpack_public_path__ + "static/media/auth-image.d83e194d.jpg";